import * as jstat from 'jstat';
import { StatSignifcanceGroup } from 'omega-rtc/views/trident-campaigns/metrics/utils';

// getStatsSignificance ...
// returns the level of confidence (0 ~ 1) that you can say that
// the better-performing alternative is really better ...
// (i.e. not better due to randomness)
// here we assume size_A, size_B > 0
export function getStatsSignificance(sizeA: number, convA: number, sizeB: number, convB: number) {
  // N2, C2 are for the better-performing alternative
  let N1 = sizeA;
  let C1 = convA;
  let N2 = sizeB;
  let C2 = convB;
  if (convA / sizeA > convB / sizeB) {
    N2 = sizeA;
    C2 = convA;
    N1 = sizeB;
    C1 = convB;
  }
  return getSignificanceHelper(N1, C1, N2, C2);
}


// getStatisticTTest...
// it returns the level of confidence (0 ~ 1) that alternative 2 is truly better
function getStatisticTTest(
  mu1: number,
  sigma1: number,
  N1: number,
  mu2: number,
  sigma2: number,
  N2: number,
  tDiff: number,
  sides: number
) {
  const statistic = (mu2 - mu1) / Math.sqrt((sigma2 / N2) + (sigma1 / N1));
  return 1 - jstat.ttest(statistic, (N1 + N2) - tDiff, sides);
}

// getSignificanceHelper...
// assumes C1/N1 < C2/N2, i.e. alternative 2 is better performin
function getSignificanceHelper(N1: number, C1: number, N2: number, C2: number) {
  const mu1 = C1 / N1;
  const mu2 = C2 / N2;
  const sigma1 = mu1 * (1 - mu1);
  const sigma2 = mu2 * (1 - mu2);
  return getStatisticTTest(mu1, sigma1, N1, mu2, sigma2, N2, 2, 1);
}

// getStatsSignificanceGroup ....
export function getStatsSignificanceGroup(
  bestGroup: StatSignifcanceGroup,
  compareGroup: StatSignifcanceGroup
) {
  return getStatisticTTest(
    compareGroup.mean,
    compareGroup.variance,
    compareGroup.count,
    bestGroup.mean,
    bestGroup.variance,
    bestGroup.count,
    2,
    1,
  );
}
